module.exports = __webpack_public_path__ + "img/oops.766772f2.png";